import React from 'react'
import { useIntl } from 'react-intl'
import { formatStyles } from '../../../../react-intl-helpers'
import { getAgentApiSettings } from '../../../../route'
import { StepContent } from '../agent-wizard-steps'
import { useOrgUuid } from '../agent-config'

export const KubernetesNoAgentsWarning = ({
  stepContentMsg
}: {
  stepContentMsg: string
}) => {
  const intl = useIntl()
  return (
    <>
      <StepContent
        step={{
          Content: {
            message: stepContentMsg
          }
        }}
      />
      <br></br>
      <br></br>

      <div data-testid="no-agents-warning">
        {intl.formatMessage(
          { id: 'detail_downloadAndSetupTheValuesFileNoAgentsWarning' },
          {
            ...formatStyles.link({
              isExternal: false,
              href: getAgentApiSettings(useOrgUuid().orgUuid)
            })
          }
        )}
      </div>
    </>
  )
}
